/**
 * Template text a generated review reply must never carry (ENG-3833): bracketed placeholders such
 * as "[Your Name]", "[Your Company]" or "[Contact Information]" that the model leaves where it
 * was never told who is replying. Shared by the server (regenerate once), the auto-reply job
 * (never post) and Studio (warn and block Publish). Pure, for tests.
 */

const PLACEHOLDER = /\[[^[\]\n]{1,60}\]/g;

/** Every bracketed placeholder in the text, in order; empty when the reply is clean. */
export function reviewReplyPlaceholders(text: string | null | undefined): string[] {
  if (!text) return [];
  return text.match(PLACEHOLDER) ?? [];
}
